// extracted by mini-css-extract-plugin
export default {"container":"ReportsPagePlaceholder__container___WgRsH","header":"ReportsPagePlaceholder__header___gIqf4"};